module.exports = __webpack_public_path__ + "../resources/img/statusbar.0a84ef25.png";